import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { useTheme } from '@mui/material/styles';
import { HotLabel } from '../../HotLabel/HotLabel';

const HelpCenterButton = props => {
  const { intl, style, isWideLayout, ...rest } = props;
  const theme = useTheme();

  return (
    <Button
      className="help-center-btn"
      style={{
        zIndex: 1,
        borderRadius: 8,
        boxShadow: '0 5px 10px rgb(126 145 221 / 28%), 0 15px 40px rgb(110 129 202 / 38%)',
        padding: 0,
        background: '#fff',
        ...style
      }}
      {...rest}
    >
      <Grid
        container
        style={{ width: '100%' }}
        sx={{
          alignItems: 'stretch'
        }}
      >
        <Grid
          style={{
            padding: 3,
            background: 'var(--new-theme)',
            borderRadius: '8px 0 0 8px'
          }}
        ></Grid>
        <Grid size="grow" style={{ padding: isWideLayout ? 10 : 8 }}>
          <Grid
            container
            style={{ height: '100%', width: '100%' }}
            sx={{
              alignItems: 'center'
            }}
          >
            <Grid size="grow">
              <Grid
                container
                spacing={1}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Grid>
                  <Grid
                    container
                    sx={{
                      alignItems: 'center'
                    }}
                  >
                    <Grid style={{ height: 25 }}>
                      <img
                        src="img/icons/closing_class_active_color.svg"
                        alt="signing-classroom"
                        width="25"
                        height="25"
                        style={{ verticalAlign: 'unset' }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid>
                  <Typography style={{ fontSize: '120%', fontWeight: '600' }}>
                    {intl.formatMessage({ id: 'signing-classroom' })}
                  </Typography>
                </Grid>
                <Grid>
                  <HotLabel
                    text={intl.formatMessage({ id: 'hot' })}
                    style={{ position: 'relative', borderRadius: 4, padding: '0 4px', top: 0, left: 0 }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <KeyboardArrowRightRoundedIcon
                style={{
                  verticalAlign: 'middle',
                  borderRadius: '50%',
                  fontSize: 20,
                  background: 'var(--new-theme)',
                  fill: theme.palette.primary.contrastText
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Button>
  );
};

export default injectIntl(HelpCenterButton);
